import {Util} from "./index";
import {STATE, GRAMMAR} from "../../Type";
import {Action, Block} from "../index";
import Line from "../../Line";

export class Ranking extends Util {
  get type() {
    return "Ranking";
  }

  get category() {
    return "Util";
  }

  getGrammarFor() {
    return GRAMMAR.SUBJECT;
  }

  getDefaultChildren() {
    return [new Block({state: STATE.INSTANCE, parent: this})];
  }

  static getPrototypeBlocks() {
    return [new Ranking({data: "ranking", state: STATE.PROTOTYPE})];
  }
  getAvailableChildTypesAt() {
    return [Action];
  }
  getAvailableParentTypes() {
    return [Line];
  }

  toJavascript() {
    const child = this.children[0];
    const childCode = child.toJavascript();
    return childCode;
  }
}
